module.exports = __webpack_public_path__ + "static/media/burst.56c482c7.svg";